export const getRandomNumber = (num: number) : number => Math.floor(Math.random() * num)